import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

interface AddCourseStudentStatusDialogProps {
  onHide: () => void;
}

export const AddCourseStudentStatusDialog: React.FC<
  AddCourseStudentStatusDialogProps
> = ({ onHide }) => {
  const [statusName, setStatusName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAddStatus = async () => {
    try {
      if (statusName.length < 3 || statusName.length > 60) {
        toast.warn('יש להזין שם בין 3 ל- 60 תווים.');
        return;
      }

      setLoading(true);
      await appApi.createCourseStudentStatus(statusName);
      await globalSettingsStores.fetchSetting();
      onHide();
    } catch (e) {
      console.error(
        `Failed to add course student status with name: ${statusName}, error: ${e}`,
      );
      toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-fluid">
      <div className="field" style={{ direction: 'rtl' }}>
        <label htmlFor="statusName">שם הסטטוס</label>
        <InputText
          id="statusName"
          value={statusName}
          onChange={(e) => setStatusName(e.target.value)}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '20px',
          gap: '10px',
        }}
      >
        <Button
          label="ביטול"
          icon="pi pi-times"
          onClick={onHide}
          className="p-button-text"
        />
        <Button
          label="שמירה"
          icon="pi pi-check"
          onClick={handleAddStatus}
          loading={loading}
        />
      </div>
    </div>
  );
};
